define('app/helper/textreader.se',[

  'lodash',
  'jquery',
  'app/helper/texttospeech.se',

  'app/app.utils'

], function (_,
  $,
  TTS,
  UTILS) {

  var LOG_LABEL = 'TextReader'

  const
    TTS_DEFAULT = 'ResponsiveVoice',
    TTS_PITCH = 1,
    TTS_RATE = 1,
    TTS_LANG = 'en-US'

  const
    DEFAULT_TTS_OPTIONS = {
      pitch: TTS_PITCH,
      rate: TTS_RATE,
      lang: TTS_LANG,
      onend: function () {
      },
      onstart: function () {
      }
    }

  /**
   * returns the approximate number of syllables for an english string
   * @param word
   * @returns {*}
   */
  function syllables (word) {
    if (word === undefined || word === '') return 0
    if (!isNaN(+word)) return ('' + word).length                     // 1 number ~ nr of digits

    word = word.toLowerCase()                                     //word.downcase!
    if (word.length <= 2) {
      return 1
    }                             //return 1 if word.length <= 3
    word = word.replace(/(?:[^laeiouy]es|ed|[^laeiouy]e)$/, '')   //word.sub!(/(?:[^laeiouy]es|ed|[^laeiouy]e)$/, '')
    word = word.replace(/^y/, '')                                 //word.sub!(/^y/, '')
    var val = word.match(/[aeiouy]{1,2}/g)                        //word.scan(/[aeiouy]{1,2}/).size
    return val ? val.length : 1
  }

  /**
   * returns the estimated milliseconds the TTS needs to speak out that sentence
   * based on the number of words and their syllables
   * @param textInput
   */
  function getSpeakingTimeEstimation (textInput) {
    var words = textInput.trim().replace(/\s+/, ' ').split(' '),
      time = words.reduce(function (res, word) {
        return res + (syllables(word) * 135) + 110// 1 syllable per 125ms + 100ms for the break
      }, 0)
    return time
  }

  /**
   * turns an html blob into a text while trying to make the best out of the html structure when translating
   * it into a text.
   * @param $input
   */
  function htmlToSpeaktext ($input) {
    var $sdom = $input.clone()

    var speakText =
      $sdom
        .html($sdom.html().replace(/<\/(div|p|li)/igm, '.</$1'))   // add a "." before each closing div,p,li tag "</"
        .text()                                     // remove tags
        .replace(/\s+/igm, ' ')                     // shrink long breaks to single spaces
        .trim()                                     // trim
        .replace(/(\s*\.\s*)+/igm, '. ')            // shrink multiple " . . . .. " into single dots
        .replace(/(^\.\s*|\.\s*$)/igm, '')          // remove trailing & leading dots
        .replace(/(\W)\./igm, '$1')                 // remove dots after non-word-chars e.g. ":."
        .replace(/\.\s/igm, '. \n\r')              // add line breaks on dots

    return speakText
  }

  /**
   * splits an html input into several sentence like chunks and returns them as a jQuery list of elements
   * @param $input
   * @returns {*|jQuery}
   */
  function getSentences ($input) {
    var sentenceNodes = []

    function extractSentences (baseNode) {
      // wrap text nodes into spans
      _.map(baseNode.childNodes, function (node) {
        var val
        switch (node.nodeType) {
          case 3: // text node
            if (!node.textContent ||
              node.textContent.trim() === '') return // ignore empty text nodes

            var newSpanNode = document.createElement('span')
            newSpanNode.classList.add('textnode-wrapper')
            newSpanNode.textContent = node.textContent.trim()
            node.replaceWith(newSpanNode)
            sentenceNodes.push(newSpanNode)

            break
          case 1: // element node
            var hasProperChildren = !!_.map(node.children).filter(function (cnode) {
              return ['span', 'u', 'i', 'b'].indexOf(cnode.tagName.toLowerCase()) === -1 &&
                cnode.innerText.trim() !== ''
            }).length
            if (hasProperChildren) {
              // same routine
              extractSentences(node)
            } else {
              sentenceNodes.push(node)
            }
            break
        }
      })
    }

    $input.each(function (i, elm) {
      extractSentences(elm)
    })

    return $().add(sentenceNodes)
  }

  var activeSpeechLibs = {} // is set on init

  /**
   * switches a selected dom element to be invisible and then reveals it word-by-word
   *
   * @param elm
   * @param options   speechlib (ResponsiveVoice, Native), pitch, rate
   * @returns {TextReader}
   *
   * @constructor
   * @method  speak   returns $.Deferred().promise()
   * @method  cancel
   *
   *
   * Example
   *
   * var textReader1 = new TextReader{
   *      elm: $('.that-item'),
   *   };
   *
   *
   */
  var TextReader = function TextReader (elm, options) {

    options = Object.assign({},
      DEFAULT_TTS_OPTIONS,
      {
        speechlib: TTS_DEFAULT,
        autostart: false
      }, options || {})

    var _this = this,
      $dom,
      q = [],
      activeSpeechLib

    function constructor () {
      if (!elm) {
        console.error(LOG_LABEL, 'missing first parameter for dom element', elm)
      }

      if (activeSpeechLibs[options.speechlib]) {
        activeSpeechLib = activeSpeechLibs[options.speechlib]
      } else {
        activeSpeechLib = activeSpeechLibs[options.speechlib] = new TTS[options.speechlib]()
      }

      $dom = $(elm)

      if ($dom.data('textreader')) {
        return // already running a text reader on that
      }
      $dom.data('textreader', _this)

      setupClassesAndPauseToggle()

      autostart()
    }

    constructor()

    function setupClassesAndPauseToggle () {

      $dom.each(function (i, elm0) {
        if ($(elm0).css('position') === 'absolute') {
          $(elm0).addClass('rp-abs')
        }
      })
      $dom.addClass('readtext-paused')

      $dom.on(UTILS.hasTouch() ? 'touchend' : 'mouseup', function (ev) {
        if (!_this.reading) {
          _this.start()

        } else if (_this.paused) {
          _this.resume()

        } else {
          _this.pause()

        }
      })

    }

    function autostart () {
      if (options.autostart) {
        var autostartDelay,
          isPromise

        switch (typeof options.autostart) {
          case  'number':
            autostartDelay = +options.autostart
            break
          case 'function':
            autostartDelay = options.autostart.apply(_this)
            break
          case 'object':
            if (options.autostart.done) {
              isPromise = true
              autostartDelay = options.autostart
            }
            break
          default:
            autostartDelay = 1
            break
        }

        var _res = $.Deferred()

        if (isPromise) {
          autostartDelay.done(function () {
            _this.start().then(_res.resolve)
          })
        } else {
          setTimeout(function () {
            _this.start().then(_res.resolve)
          }, autostartDelay)
        }
        _this.then = _res.promise().then
      }
    }

    function speak (textValue) {
      var _res = $.Deferred()

      //console.log(LOG_LABEL, textValue);

      if (textValue === '') {
        _res.resolve()

      } else {

        var options0 = {
          lang: options.lang,
          pitch: options.pitch,
          rate: options.rate,
          onstart: function () {
            // not working reliable
          },
          onend: function () {
            // not working reliable
          },
          onpause: function () {
            _this.paused = true
          },
          onresume: function () {
            _this.paused = false
          }
        }

        activeSpeechLib.speak(textValue, null, options0)

        var estimatedSpeakingTime = getSpeakingTimeEstimation(textValue)

        // earliest trigger "end" after 90% of the estimated speaking time - iOs hack
        setTimeout(function () {
          var isSpeaking = setInterval(function () {
            var inst = activeSpeechLib.getInst()
            if (inst.isPlaying && inst.isPlaying() || inst.speaking) {
              return // still playing
            }
            clearInterval(isSpeaking)

            console.log('speak', 'end')
            options.onend.apply(this)

            _res.resolve()
          }, 50)
        }, estimatedSpeakingTime * 0.9)

        setTimeout(function () {
          // on start.
          console.log('speak', 'start')
          options.onstart.apply(this)
          _res.notify('START')
        }, 1)

      }

      return _res.promise()
    }

    /**
     * prepares the $input to be wrapped word by word and then on run() reveiled word by word
     * @param $input
     * @returns {{next: showNextWord, reset: resetInput, run: run}}
     */
    function createBubbler ($input) {
      var origHtml = $input.html(),
        _res = $.Deferred()

      function wrapWords () {
        var tagIsOpen
        $input.html(function (_, html) {
          return html
            .replace(/<([^>]+)>/igm, ' <$1> ')  // add additional space before and after <tags>
            .split(/\s+/)                       // split by (multiple)spaces
            .reduce(function (c, n) {           // wrap non-tag parts with <span.readtext-invisible/>
              if (n.trim().match(/^<([^>]+)>$/)) {
                return c + n
              } else if (n.trim().match(/^<[a-zA-Z]/) && !tagIsOpen) {
                tagIsOpen = true
                return c + n
              } else if (tagIsOpen) {
                if (n.trim().match(/>$/)) {
                  tagIsOpen = false
                }
                return c + ' ' + n
              }

              return c + '<span class="readtext-invisible">' + n.trim() + ' </span>'

            }, '')
        })
        $input.find('div, p, li, img, td, th').not('.readtext-invisible').addClass('readtext-invisible')

      }

      function getNextInvisibleTextBlock () {
        return $input.find('.readtext-invisible:not(.in)').first()
      }

      function showNextWord () {
        var wasWord,
          $nextTextBlock = true

        while (!wasWord && $nextTextBlock) {
          $nextTextBlock = getNextInvisibleTextBlock()

          if (!$nextTextBlock.length) {
            return
          }

          if ($nextTextBlock.children().length === 0) {
            wasWord = true
          }

          $nextTextBlock.addClass('in')
        }

        return $nextTextBlock.text()
      }

      function resetInput () {
        $input.html(origHtml)
      }

      function run () {
        function nextWord () {
          var startTime = Date.now(),
            currentWord = showNextWord()

          if (currentWord === undefined) {
            _res.resolve()
            return // ended.
          }

          var speed = getSpeakingTimeEstimation(currentWord)

          speed *= options.rate || 1

          // taking performance delay into account
          var performanceDelay = Date.now() - startTime

          setTimeout(function () {

            if (_this.cancelled) {
              _res.resolve()
              // forced end.
            } else if (_this.paused) {
              var pauseInterval = setInterval(function () {
                if (!_this.paused) {
                  clearInterval(pauseInterval)
                  if (_this.reading) {
                    nextWord()
                  }
                }

              }, speed)
            } else {
              nextWord()
            }

          }, speed - performanceDelay)
        }

        nextWord()

      }

      wrapWords()

      return {
        next: showNextWord,
        reset: resetInput,
        run: run,
        done: _res.promise().done
      }
    }

    function readSentenceFn ($input, qStart) {
      return function () {
        var textInput = htmlToSpeaktext($input),
          textBubbler = createBubbler($input)

        $input.addClass('in')

        function nextItemInQueue () {
          setTimeout(function () {
            if (q.length) {
              q.shift().apply(_this)
            } else {
              qStart.resolve()
            }
          }, 250)
        }

        var speaker = speak(textInput)

        speaker.progress(function (state) {
          switch (state) {
            case 'START':
              textBubbler.run()
              break
          }

        })

        speaker.done(function () {
          textBubbler.done(function () {
            textBubbler.reset()

            if (_this.cancelled) {
              qStart.resolve()
              // forced end.
            } else if (_this.paused) {
              var pauseInterval = setInterval(function () {
                if (!_this.paused) {
                  clearInterval(pauseInterval)
                  if (_this.reading) {
                    nextItemInQueue()
                  }
                }
              }, 100)
            } else {
              nextItemInQueue()
            }

          })
        })
      }
    }

    function queueSentences ($sentences, qStart) {
      $sentences.addClass('readtext-invisible')
      $sentences.addClass('readtext-sentence')

      $sentences.each(function (i, elm) {
        var $input = $(elm)

        var textInput = htmlToSpeaktext($input)
        if (textInput === '') return

        q.push(readSentenceFn($input, qStart))
      })
    }

    this.reading = false
    this.paused = false
    this.pending = false
    this.cancelled = false

    this.start = function start (forced) {
      var _this = this,
        qStart = $.Deferred(),
        $bubbleTexts = $dom,
        $sentences = getSentences($bubbleTexts)

      if (_this.pending && !forced) return

      this.cancel()

      queueSentences($sentences, qStart)
      this.pending = true

      activeSpeechLib.init().then(function () {
        $dom.removeClass('readtext-paused')
        setTimeout(function () {
          _this.reading = true
          _this.cancelled = false
          q.shift().apply(this)
        }, 25)
      })

      qStart.then(function () {
        _this.reading = false
        _this.pending = false
        _this.paused = false
      })

      return qStart.promise()
    }

    this.pause = function () {
      if (activeSpeechLib && activeSpeechLib.getInst() && _this.reading) {
        activeSpeechLib.getInst().pause()
        _this.paused = true
        $dom.addClass('readtext-paused')
      }
    }

    this.resume = function () {
      if (activeSpeechLib && activeSpeechLib.getInst() && _this.paused) {
        activeSpeechLib.getInst().resume()
        _this.paused = false
        $dom.removeClass('readtext-paused')
      }
    }

    this.cancel = function cancel () {
      q = []
      this.cancelled = true
      this.pending = true
      if (!activeSpeechLib || !activeSpeechLib.cancel) return
      activeSpeechLib.cancel()
    }

    return this
  }

  return TextReader

});
